export const getEnergyClassColor = (energyClass: string) => {
    const colors: { [key: string]: string } = {
        'A': 'success',
        'B': 'success',
        'C': 'info',
        'D': 'warning',
        'E': 'warning',
        'F': 'error',
        'G': 'error'
    };
    return colors[energyClass] || 'default';
};